import type { StateService, UIRouterGlobals } from "@uirouter/angularjs";
import type { IScope } from "angular";
import { isEmpty } from "lodash";
import { finalize } from "rxjs/operators";

import type { IAccountRepository } from "App/Modules/Auth";
import type { IResponseWithLoading, IUserVerification } from "App/Modules/Models";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

export default class ConfirmVerificationComponentController {
    public static $inject: string[] = ["$scope", "$state", "$uiRouterGlobals", "mmAccountRepository"];

    public userVerification: IUserVerification;

    public verifyUserResponse: IResponseWithLoading<void>;

    constructor(
        private readonly $scope: IScope,
        private readonly $state: StateService,
        private readonly $uiRouterGlobals: UIRouterGlobals,
        private readonly accountRepository: IAccountRepository,
    ) {}

    public $onInit() {
        this.userVerification = {
            password: null,
            verificationKey: this.$uiRouterGlobals.params.verificationKey,
        };
    }

    public verify() {
        if (!isEmpty(this.userVerification)) {
            this.verifyUserResponse = { isLoading: true };
            extendWithLoadingAndFail(this.accountRepository.verifyUser(this.userVerification))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<void>) => {
                        this.verifyUserResponse = response;
                        if (!response.isLoading && !response.hasError) {
                            this.$state.go("login");
                        }
                    },
                    (error) => {
                        this.verifyUserResponse = error;
                    },
                );
        }
    }
}
